// extracted by mini-css-extract-plugin
export default {"assignments":"AssignmentFieldLayout_assignments__npCwS","label":"AssignmentFieldLayout_label__hrOB4","assignment":"AssignmentFieldLayout_assignment__r4+Ni"};